package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import io.horion.cv.components.widgets.RichTextDescription
import org.jetbrains.compose.web.css.px

@Composable
fun DownPageForm() {

    var content by remember { mutableStateOf("") }

    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(10.px),
    ) {
        RichTextDescription(
            label = "Contenu",
            value = content,
            onValueChange = { content = it },
            modifier = Modifier.fillMaxWidth(),
        )
    }
}